import React from "react";
import cn from "./helpers/cn";
import { DialogContext, } from "./Dialog";

interface DialogContentProps extends React.HTMLAttributes<HTMLDivElement> {
  component?: React.ElementType;
  dividers?: boolean;
  children?: React.ReactNode;
}

const DialogContent = React.forwardRef<HTMLDivElement, DialogContentProps>((props, ref) => {
  const {
    className,
    component: Component = "div",
    dividers = false,
    children,
    ...other
  } = props;

  const ctx = React.useContext(DialogContext);
  const isPaperScroll = ctx?.scroll !== "body";

  return (
    <Component
      ref={ref}
      className={cn(
        // MUI v4: padding 8px 24px (vira 16px 24px se houver dividers ao redor),
        // flex 1 1 auto para crescer/encolher dentro do paper.
        "px-6 py-2 flex-1 overflow-y-auto",

        // Em scroll body, o conteúdo não rola sozinho (rola o container).
        !isPaperScroll && "overflow-visible",

        dividers && "py-4 border-y border-slate-200",

        className
      )}
      {...other}
    >
      {children}
    </Component>
  );
});

DialogContent.displayName = "DialogContent";

export default DialogContent;
